import React from 'react';
import PrivacyPolicyNav from '../Components/PrivacyPolicy/PrivacyPolicyNav';
import PrivacyPolicyContent from '../Components/PrivacyPolicy/PrivacyPolicyContent';
import SEO from '../Components/SEO/SEO';
import Spacing from '../Components/Spacing/Spacing';
import { useLanguage } from '../contexts/LanguageContext';

const PrivacyPolicyPage = () => {
  const { t } = useLanguage();
  
  return (
    <>
      <SEO
        title={t('privacy.meta.title')}
        description={t('privacy.meta.description')}
        image="/images/logo.svg"
      />
      <Spacing lg={120} md={80} />
      <div className="container">
        <div className="row">
          <div className="col-lg-3 col-md-4">
            <PrivacyPolicyNav />
          </div>
          <div className="col-lg-9 col-md-8">
            <PrivacyPolicyContent />
          </div>
        </div>
      </div>
      <Spacing lg={120} md={80} />
    </>
  );
};

export default PrivacyPolicyPage;
